import { render, staticRenderFns } from "./SendGroupListForCoupon.vue?vue&type=template&id=22af1307"
import script from "./SendGroupListForCoupon.vue?vue&type=script&lang=js"
export * from "./SendGroupListForCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports